module.exports = {
      id: "recommendation-usage",
      viewBox: "0 0 39 38",
      url: "img/" + "sprite.svg#recommendation-usage",
      toString: function () {
        return this.url;
      }
    }